import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTransition = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M12.34 14.503a.75.75 0 0 1-.114-1.055l2.81-3.489-2.81-3.488a.75.75 0 0 1 1.168-.941l3.57 4.43-3.57 4.43a.75.75 0 0 1-1.054.113"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M7.934 14.503a.75.75 0 0 1-.114-1.055l2.81-3.489-2.81-3.488a.75.75 0 1 1 1.168-.941l3.569 4.43-3.569 4.43a.75.75 0 0 1-1.054.113"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M3.53 14.503a.75.75 0 0 1-.114-1.055l2.81-3.489-2.81-3.488a.75.75 0 1 1 1.168-.941l3.569 4.43-3.569 4.43a.75.75 0 0 1-1.054.113"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTransition;
